import React, { useEffect, useState } from 'react';
import '../style/Rewards.css';
import { useNavigate } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Rewards = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  }, [navigate]);

  const faqs = [
    {
      question: 'How does the Tringbox Refer & Earn program work?',
      answer:
        'Invite your friends to Tringbox. When your friend buys a ₹499 coin pack, both of you get ₹250 off on your next coin purchase.',
    },
    {
      question: 'When will I receive my ₹250 discount?',
      answer:
        'You’ll receive the ₹250 discount after your friend successfully completes the purchase of a ₹499 coin pack.',
    },
    {
      question: 'Is there a limit to how many friends I can refer?',
      answer:
        'No, you can refer as many friends as you want. Each successful referral will unlock a ₹250 discount for you.',
    },
    {
      question: 'Can I use multiple ₹250 discounts on a single purchase?',
      answer:
        'No, you can use only one ₹250 referral discount per coin purchase.',
    },
    {
      question: 'Can my friend use the discount on any coin pack?',
      answer:
        'No, the ₹250 discount applies only to their first coin purchase of ₹499 or more.',
    },
    {
      question: 'Where can I claim my offer?',
      answer:
        "You can claim your offer in the 'Referral' section of the Tringbox app. You'll need to buy the coin pack from the same section by clicking the 'Claim' button for both the referrer and the referee",
    },
  ];

  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleFAQ = index => {
    setOpenIndexes(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  return (
    <div
      className="rewards-container d-flex flex-column align-items-center overflow-scroll mb-5"
      style={{ scrollBehavior: 'smooth', height: '93dvh' }}
    >
      <img
        src="images/rewards2gif.gif"
        className="mb-1"
        style={{ width: '100%', height: '40%' }}
      />

      {/* <span className="common-txt mt-2" style={{ color: "#838383" }}>
        - Invite Friends Via -
      </span> */}

      {/* <div
        className="d-flex flex-row justify-content-between mt-4"
        style={{ width: "85%" }}
      >
        <button
          style={{ border: "none", backgroundColor: "white" }}
          className="d-flex flex-column w-25"
        >
          <img
            className="p-2"
            src="images/whatsapp.png"
            style={{
              borderRadius: "15px",
              border: "1px solid #EBEBEB",
              background: "#F6F6F6",
              height: "70px",
              width: "100%",
            }}
          />
          <span className="mt-3 common-txt" style={{ color: "#5B5B5B" }}>
            Whatsapp
          </span>
        </button>

        <button
          style={{ border: "none", backgroundColor: "white" }}
          className="d-flex flex-column w-25"
        >
          <img
            className="p-2"
            src="images/share.svg"
            style={{
              borderRadius: "15px",
              border: "1px solid #EBEBEB",
              background: "#F6F6F6",
              height: "72px",
            }}
          />
          <span className="mt-3 common-txt" style={{ color: "#5B5B5B" }}>
            Share
          </span>
        </button>

        <button
          style={{ border: "none", backgroundColor: "white" }}
          className="d-flex flex-column w-25"
        >
          <img
            className="p-2"
            src="images/copylink.svg"
            style={{
              borderRadius: "15px",
              border: "1px solid #EBEBEB",
              background: "#F6F6F6",
              height: "70px",
            }}
          />
          <span className="mt-3 common-txt" style={{ color: "#5B5B5B" }}>
            Copy Link
          </span>
        </button>
      </div> */}

      {/* <div
        className="d-flex flex-row justify-content-between mt-4"
        style={{ width: "85%" }}
      >
        <div>
          <span
            className="common-txt"
            style={{ color: "#838383", fontSize: "17px", fontWeight: 500 }}
          >
            Invitation Code:{" "}
          </span>
          <span
            className="common-txt"
            style={{ color: "#525252", fontWeight: 700, fontSize: "22px" }}
          >
            LMNO6654WQ
          </span>
        </div>
        <img src="images/copy.svg" />
      </div> */}

      <div
        className=" mt-3 mb-1 d-flex flex-row align-items-center p-2 justify-content-between"
        style={{
          borderRadius: '10px',
          background: 'linear-gradient(90deg, #B61E32 0%, #883162 100%)',
          width: '95%',
          gap: '20px',
        }}
      >
        <h5 className="text-start mx-2 mb-0" style={{ color: 'white' }}>
          Download our app and get 2 coins free worth Rs. 99/-
        </h5>
        <button
          className="p-2"
          style={{
            whiteSpace: 'nowrap',
            color: 'white',
            borderRadius: ' 10px',
            border: '2px solid #FFF',
            background: 'transparent',
          }}
        >
          <h6 className="mb-0">Download App</h6>
        </button>
      </div>

      {/* <div className="text-start mt-2" style={{ width: "90%" }}>
        <h4 className="">Referrals</h4>
        <hr />
      </div> */}

      <h5 className="text-start mt-3 mb-1" style={{ width: '95%' }}>
        How Referral Works:
      </h5>
      <div
        className="w-100 mt-2 mb-1 d-flex flex-column align-items-center"
        style={{ backgroundColor: '#F1F1F1' }}
      >
        <div
          className="mt-3 py-2 text-start d-flex flex-row justify-content-start align-items-center"
          style={{
            width: '90%',
            paddingLeft: '20px',
            paddingRight: '20px',
            background: '#FFF',
            borderRadius: '10px',
            height: '5rem',
          }}
        >
          <span
            className="d-flex flex-column"
            style={{
              background: 'linear-gradient(180deg, #CC151E 0%, #8D335D 100%)',
              fontSize: '2rem',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 700,
            }}
          >
            1
          </span>
          <span
            className="common-txt text-start mx-3"
            style={{
              color: '#4C4C4C',
              fontWeight: 600,
              marginLeft: '10px',
              marginRight: '10px',
            }}
          >
            Invite your friends to Tringbox
          </span>
          <div
            className="d-flex flex-row align-items-center justify-content-end"
            style={{ flexGrow: 1 }}
          >
            <img style={{ height: '2rem' }} src="images/how1.svg" />
          </div>
        </div>

        <div
          className="mt-3 py-2 text-start d-flex flex-row justify-content-start align-items-center"
          style={{
            width: '90%',
            paddingLeft: '20px',
            paddingRight: '20px',
            background: '#FFF',
            borderRadius: '10px',
            height: '5rem',
          }}
        >
          <span
            style={{
              background: 'linear-gradient(180deg, #CC151E 0%, #8D335D 100%)',
              fontSize: '2rem',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 700,
            }}
          >
            2
          </span>
          <span
            className="common-txt mx-3 text-start"
            style={{
              color: '#4C4C4C',
              fontWeight: 600,
              marginLeft: '10px',
              marginRight: '10px',
            }}
          >
            They buy a ₹499 coin pack at ₹249
          </span>
          <div
            className="d-flex flex-row align-items-center justify-content-end"
            style={{ flexGrow: 1 }}
          >
            <img style={{ height: '2.5rem' }} src="images/how2.svg" />
          </div>
        </div>

        <div
          className="mt-3 mb-3 pt-3 pb-3 text-start d-flex flex-row justify-content-start align-items-center"
          style={{
            width: '90%',
            paddingLeft: '20px',
            paddingRight: '20px',
            background: '#FFF',
            borderRadius: '10px',
          }}
        >
          <span
            style={{
              background: 'linear-gradient(180deg, #CC151E 0%, #8D335D 100%)',
              fontSize: '2rem',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 700,
            }}
          >
            3
          </span>
          <span
            className="common-txt mx-3 text-start"
            style={{
              color: '#4C4C4C',
              fontWeight: 600,
              marginLeft: '15px',
              marginRight: '10px',
            }}
          >
            You get ₹250 OFF on your next coin purchase!
          </span>
          <div
            className="d-flex flex-row align-items-center justify-content-end"
            style={{ flexGrow: 1 }}
          >
            <img style={{ height: '2.3rem' }} src="images/how3.svg" />
          </div>
        </div>
      </div>

      <div
        className="mb-5 d-flex flex-column align-items-center"
        style={{ width: '95%' }}
      >
        <h5 className="mt-3 w-100 mb-0 text-start">FAQ's</h5>
        <div className="mb-3" style={{ width: '95%' }}>
          {faqs.map((faq, index) => (
            <div
              className="text-start"
              key={index}
              style={{
                borderBottom: '1px solid #ccc',
                padding: '15px 0',
              }}
            >
              <div
                onClick={() => toggleFAQ(index)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  fontWeight: 500,
                  fontSize: '1rem',
                  color: '#4C4C4C',
                  marginRight: '10px',
                }}
              >
                {faq.question}
                {openIndexes.includes(index) ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )}
              </div>
              {openIndexes.includes(index) && (
                <div
                  style={{
                    marginTop: '0.5rem',
                    color: '#A8A8A8',
                    fontSize: '0.8rem',
                  }}
                >
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rewards;
